// src/App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import Login from "./Login";
import Dashboard from "./Dashboard";
import AdminPanel from "./AdminPanel";
import Buttcrbti from "./buttcrbti";
import Flight from "./flight";
import UTSP from "./UTSP";
import Stats from "./stats"; // ייבוא של קומפוננטת הסטטיסטיקות החדשה
import TpMilestoneSimulator from './TpMilestoneSimulator';
import MentorRankingDashboard from './MentorRankingDashboard';
import Live from './Live';
import BackupPage from './BackupPage';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // מצב טעינה

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log("Current user:", currentUser);
      setUser(currentUser);
      setLoading(false); // עדכון מצב הטעינה כשהסטייט נטען
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    // ניתן להציג מסך טעינה, Spinner או הודעה פשוטה
    return <div>טוען...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={!user ? <Login /> : <Navigate to="/dashboard" />}
        />
<Route
  path="/mentor-ranking"
  element={user ? <MentorRankingDashboard user={user} /> : <Navigate to="/login" />}
/>        <Route
          path="/dashboard"
          element={user ? <Dashboard user={user} /> : <Navigate to="/login" />}
        />
        <Route
          path="/admin"
          element={user ? <AdminPanel /> : <Navigate to="/login" />}
        />
        <Route
          path="/metor"
          element={user ? <AdminPanel /> : <Navigate to="/login" />}
        />
        <Route
          path="/live"
          element={user ? <Live /> : <Navigate to="/login" />}
        />
        <Route
          path="/stats"
          element={user ? <Stats /> : <Navigate to="/login" />}
        />
        <Route
          path="/buttcrbti"
          element={user ? <Buttcrbti /> : <Navigate to="/login" />}
        />
        <Route
          path="/flight"
          element={user ? <Flight /> : <Navigate to="/login" />}
        />
        <Route
          path="/utsp"
          element={user ? <UTSP /> : <Navigate to="/login" />}
        />
         <Route
          path="/BackupPage"
          element={user ? <BackupPage /> : <Navigate to="/login" />}
        />
        {/* הוספת הנתיב החדש לסימולטור TP Milestone */}
        <Route
          path="/tp-milestone-simulator"
          element={user ? <TpMilestoneSimulator /> : <Navigate to="/login" />}
        />
        <Route
          path="*"
          element={<Navigate to={user ? "/dashboard" : "/login"} />}
        />
      </Routes>
    </Router>
  );
}

export default App;